import { useDeviceType } from '@cian/ui-kit';
import { StartBlock } from 'shared/components/SmbPage';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const StartBlockContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const device = useDeviceType();

  const image = config.get<string>('b2b-marketing-guide-frontend.smb.startBlock.image');

  return <StartBlock device={device} image={image} />;
};
